@if (error) {
  <app-error-page
    [heading]="error.heading"
    [message]="error.message"
    [operationId]="error.operationId">
  </app-error-page>
} @else {
  <app-header
    [showVisDetaljer]="!showOrderDetails"
    [showTicketContent]="showOrderDetails"
    (openDetails)="showOrderDetails = true"
    (closeDetails)="showOrderDetails = false">
  </app-header>
  @if (orderData$ | async; as orderData) {
    @if (localeKey$ | async; as locale) {
      @if (showOrderDetails) {
        <app-order-details
          [orderData]="orderData"
          [locale]="locale">
        </app-order-details>
      } @else {
        <main class="main-content">
          <div class="ticket-container">
            <div class="ticket-time" [ngClass]="getTicketValidityClass(orderData)">
              @if (getTicketValidityClass(orderData) === '') {
                <span class="ticket-time__clock">{{ clockText }}</span>
                <span class="ticket-time__day">{{ dayText | titlecase }}</span>
              } @else {
                <span class="ticket-time__status">
                  {{ getTicketTimeLeft(orderData) }}
                </span>
              }
            </div>
            <div class="ticket-content">
              <div class="ticket-section">
                <span class="ticket-label">{{ 'web.ticketPassengerLabel' | translate }}</span>
                @for (passenger of passengers; track passenger) {
                  <div class="ticket-passengers">
                    <span class="ticket-passengers__number">{{ passenger.count }}</span>
                    <span class="ticket-passengers__x">x</span>
                    <span class="ticket-passengers__type">{{ getDisplayPassengerType(passenger, orderData) | translate }}</span>
                  </div>
                }
              </div>
              <div class="ticket-divider"></div>
              <div class="ticket-section">
                <span class="ticket-label">{{ 'web.ticketNameLabel' | translate }}</span>
                <span class="ticket-value">{{ utility.getLocalizedText(orderData.specialTicket?.ticketName, locale) }}</span>
              </div>
              <div class="ticket-divider"></div>
              <div class="ticket-section">
                <div class="ticket-section__header">
                  <span class="ticket-label">{{ 'web.ticketNumberOfZonesLabel' | translate }}</span>
                </div>
                <span class="ticket-value">{{ orderData.validZones.length }} {{'web.zones' | translate | lowercase }}</span>
                <div class="ticket-zones">
                  <span class="ticket-zones__title">{{ 'web.ticketValidZonesLabel' | translate }}</span>
                  <div class="ticket-zones__badges">
                    @for (zone of orderData.validZones; track zone) {
                      <span class="ticket-badge">
                        {{ utility.formatZoneCode(zone) }}
                      </span>
                    }
                  </div>
                </div>
              </div>
              <div class="ticket-divider"></div>
              <div class="ticket-section">
                <span class="ticket-label">{{ 'web.ticketValidToLabel' | translate }}</span>
                <span class="ticket-value">{{ orderData.validTo | danishTime | date:'dd.MM.yy, HH:mm:ss' }}</span>
              </div>
            </div>
          </div>
          <app-inspection-footer [orderData]="orderData" [isTicketValid]="isTicketPaid(orderData)"></app-inspection-footer>
        </main>
      }
    }
  }
}

